// Spanish for the SOS Field app: sign in, home screen and the personal account card.
// Keys are the English text exactly as written in the code.
export default {
  'Could not sign in': 'No se pudo entrar',
  'Sign in': 'Entrar',
  'Employee access': 'Acceso de empleados',
  'Step 1 of 3': 'Paso 1 de 3',
  'Hi, crew!': '¡Hola, equipo!',
  'Ready for your shift?': '¿Listo para tu turno?',
  'Field workflow': 'Pasos en el campo',
  'Clock in': 'Marcar entrada',
  'Take photos': 'Tomar fotos',
  'Use your personal phone number and the PIN the office gave you. That opens your clock and your hours. The crew phone and crew PIN also open the app.':
    'Usa tu número de teléfono y el PIN que te dio la oficina. Así abres tu reloj y tus horas. El teléfono y el PIN del equipo también abren la app.',
  'Phone number': 'Número de teléfono',
  'Your PIN': 'Tu PIN',
  'Enter your PIN': 'Escribe tu PIN',
  'Install SOS Field for Android': 'Instalar SOS Field en Android',
  'Your workday': 'Tu día de trabajo',
  'Hi, {name}.': 'Hola, {name}.',
  there: 'amigo',
  'Clock in, take job photos or open Sales.':
    'Marca tu entrada, toma fotos del trabajo o abre Ventas.',
  'Clock in and take job photos.': 'Marca tu entrada y toma fotos del trabajo.',
  'Your tools': 'Tus herramientas',
  'Job photos: take photos of the job and send them to the office.':
    'Fotos del trabajo: toma fotos y mándalas a la oficina.',
  'Open CompanyCam': 'Abrir CompanyCam',
  'Your hours: every day, the week total and each clock in and out.':
    'Tus horas: cada día, el total de la semana y cada entrada y salida.',
  'Connect your personal account to see your hours.':
    'Conecta tu cuenta personal para ver tus horas.',
  'See my hours': 'Ver mis horas',
  'Connect account': 'Conectar cuenta',
  'Find customers, make estimates and send contracts to sign.':
    'Busca clientes, haz presupuestos y manda contratos para firmar.',
  'Open Sales': 'Abrir Ventas',
  'Personal account needed': 'Necesitas una cuenta personal',
  'Start your workday': 'Empieza tu día de trabajo',
  'You came in with the crew phone. To clock in, connect your own account: your phone number and your personal PIN from the office.':
    'Entraste con el teléfono del equipo. Para marcar tu entrada, conecta tu propia cuenta: tu número de teléfono y tu PIN personal de la oficina.',
  'Connect my personal account': 'Conectar mi cuenta personal',
  'Need a personal PIN?': '¿Necesitas un PIN personal?',
  'The office gives you access in Setup → Crews → your crew → SOS Field app. You get your own PIN.':
    'La oficina te da acceso en Setup → Crews → tu equipo → SOS Field app. Recibes tu propio PIN.',
  'Open office setup': 'Abrir la configuración de la oficina',
  'Connect your personal account': 'Conecta tu cuenta personal',
  'Use your own phone number and the personal PIN the office gave you (not the crew PIN). Your hours will be saved under your name.':
    'Usa tu propio número de teléfono y el PIN personal que te dio la oficina (no el PIN del equipo). Tus horas se guardan con tu nombre.',
  'Your phone number': 'Tu número de teléfono',
  'Personal PIN': 'PIN personal',
  'This phone does not share its location.':
    'Este teléfono no comparte su ubicación.',
  'Location is blocked. Allow location for this site in your browser settings.':
    'La ubicación está bloqueada. Permite la ubicación para este sitio en los ajustes del navegador.',
  'Could not get your location. Try again outside or search by name.':
    'No se pudo obtener tu ubicación. Intenta afuera o busca por nombre.',
  'You’re {distance} from this job ({job}).':
    'Estás a {distance} de este trabajo ({job}).',
  'You’re {distance} from this job.': 'Estás a {distance} de este trabajo.',
  'Add the photo to this job anyway?':
    '¿Agregar la foto a este trabajo de todos modos?',
  'Add {count} photos to this job anyway?':
    '¿Agregar {count} fotos a este trabajo de todos modos?',
} as Record<string, string>
